// extracted by mini-css-extract-plugin
export var centerText = "_6x-8";
export var container = "_6x-0";
export var doughnutContainer = "_6x-7";
export var legend = "_6x-a";
export var legendItemColorDisplay = "_6x-b";
export var legendItemLabel = "_6x-d";
export var legendItemValue = "_6x-c";
export var lg = "_6x-5";
export var maxWidth = "_6x-9";
export var md = "_6x-4";
export var responsive = "_6x-6";
export var sm = "_6x-3";
export var xs = "_6x-2";
export var xxs = "_6x-1";